import React, { Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";
import { jobs } from "../CareerSection/jobs";

const CareerDetails: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const job = slug ? jobs.find((item) => item.slug === slug) : undefined;

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={job ? job.title : "Career details"} pagesub="Careers" />
            <section className="career-details">
              <div className="container">
                <div className="cp-details-wrap">
                  <Link to="/career" className="thm-btn agency-btn mb-30">
                    <span className="text">Back to open positions</span>
                  </Link>
                  {job ? (
                    <>
                      <div className="cp-manager_info">
                        <h2 className="details-content-title mb-30">{job.title}</h2>
                        <ul className="xb-details-content list-unstyled mb-35">
                          <li><span>Location :</span> {job.location}</li>
                          <li><span>Qualifications :</span> {job.qualification}</li>
                        </ul>
                      </div>
                      {job.sections.map((section, index) => (
                        <div className="xb-details-item" key={`${section.title}-${index}`}>
                          <h3 className="details-title mt-70">{section.title}</h3>
                          <ul className="content-list mt-25">
                            {section.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
                          </ul>
                        </div>
                      ))}
                      <ApplyForm key={job.slug} jobTitle={job.title} applicationUrl={job.sourceUrl} />
                    </>
                  ) : (
                    <div className="cp-manager_info">
                      <h2 className="details-content-title mb-30">
                        {slug ? "Position not found" : "Choose an open position"}
                      </h2>
                      <p>Select a position from the careers page to view its details and apply.</p>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};
export default CareerDetails;
